import { render } from "./BlankPageSalesTwo.vue?vue&type=template&id=1c5695ab&scoped=true"
import script from "./BlankPageSalesTwo.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesTwo.vue?vue&type=script&lang=js"

import "./BlankPageSalesTwo.vue?vue&type=style&index=0&id=1c5695ab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5695ab"]])

export default __exports__